<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-tabs 
				app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/'}">Prodotto</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/' + (model.serials ? 'serials' : 'lots')}" key="lots" v-if="loaded && (model.lots || model.serials)">{{ model.serials ? 'Matricole' : 'Lotti' }}</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/units'}" key="units" v-if="loaded">Unità di misura</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/attributes'}" key="attributes" v-if="loaded && model.product_type == 'variable'">Attributi</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/variants'}" key="variants" v-if="loaded && model.product_type == 'variable'">Varianti</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/components'}" key="components" v-if="loaded && model.product_type == 'kit'">Componenti</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/analytics'}" key="analytics" v-if="$store.getters.checkModulePermissions('products')">Statistiche</v-tab>
                <v-tab exact-path ripple :to="{ path: '/products/' + id + '/movements'}" key="movements" v-if="$store.getters.checkModelPermissions('movement')">Movimenti</v-tab> 
			</v-tabs>


            <v-slide-y-reverse-transition>
                <router-view v-show="!$store.getters.progress" :key="$route.fullPath" :entity-title="entityTitle"></router-view>
            </v-slide-y-reverse-transition>

        </v-col>
    </v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'product-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
                loaded: false
            }
        },

        computed: {
            entityTitle()  {
                return ['code', 'name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' - ')
            }
        },

        created() {
            this.axios.get('products/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model
                this.$store.commit('endProgress')
                this.loaded = true

            }, response => {
                // error callback
            })
        },
    }
</script>